import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { LoginView, LoginStyles } from 'app/auth'
import Formsy from 'formsy-react'
import { Box } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { TextFieldFormsy } from '@fuse/core/formsy'
import { Icon, InputAdornment } from '@material-ui/core'
import { loginSuccess } from 'app/auth/store/loginSlice'
import apiService from 'app/services/apiService'

function Pin() {
	const classes = LoginStyles()
	const [isFormValid, setIsFormValid] = useState(false)
	const [showPin, setShowPin] = useState(false)
	const [username, setUsername] = useState(null)
	const dispatch = useDispatch()
	const formRef = useRef(null)

	const disableButton = () => {
		setIsFormValid(false)
	}

	const enableButton = () => {
		setIsFormValid(true)
	}

	const handleSubmit = model => {
		if (model.pin) {
			apiService.validateLoginPin(username, model.pin).then(token => {
				if (token) {
					apiService.setSession(token)
					apiService.emit('onAutoLogin', true)
					dispatch(loginSuccess(true))
				} else {
					setTimeout(() => {
						if (formRef.current) {
							formRef.current.updateInputsWithError({
								pin: 'Invalid pin'
							})
						}
					}, 0)
				}
			})
		} else {
			apiService.createLoginPin(username).then(created => {
				if (created) {
					setShowPin(true)
					setTimeout(() => {
						setShowPin(false)
					}, 120000)
					dispatch(loginSuccess(['Please check your email for your pin']))
				} else {
					setTimeout(() => {
						if (formRef.current) {
							formRef.current.updateInputsWithError({
								email: 'Pin not supported for this user'
							})
						}
					}, 0)
				}
			})
		}
	}

	return (
		<LoginView classes={classes}>
			<Formsy
				onValidSubmit={handleSubmit}
				onValid={enableButton}
				onInvalid={disableButton}
				ref={formRef}
				className="flex flex-col justify-center w-full"
			>
				<Box className="relative w-full">
					<TextFieldFormsy
						className="mb-16 w-full"
						type="text"
						name="email"
						label="Username/Email"
						value={username}
						validations={{
							minLength: 4
						}}
						validationErrors={{
							minLength: 'Min character length is 4'
						}}
						InputProps={{
							disabled: showPin,
							endAdornment: (
								<InputAdornment position="end">
									<Icon className="text-20" color="action">
										email
									</Icon>
								</InputAdornment>
							)
						}}
						onChange={e => {
							setUsername(e.target.value)
						}}
						variant="outlined"
						required
					/>
				</Box>

				{showPin && (
					<TextFieldFormsy
						className="mb-16"
						type="text"
						name="pin"
						label="Pin"
						value=""
						validations={{
							minLength: 4
						}}
						validationErrors={{
							minLength: 'Min character length is 4'
						}}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<Icon className="text-20" color="action">
										phonelink_lock
									</Icon>
								</InputAdornment>
							)
						}}
						variant="outlined"
						required
					/>
				)}

				<Button
					type="submit"
					name="button"
					variant="contained"
					color="primary"
					className="w-full mx-auto mt-16 normal-case"
					aria-label={showPin ? 'VALIDATE PIN' : 'GET PIN'}
					disabled={!isFormValid}
				>
					{showPin ? 'Validate Pin' : 'Get Pin'}
				</Button>
			</Formsy>
		</LoginView>
	)
}

export default Pin
